module.exports = __webpack_public_path__ + "contadorsolo.svg?cec0c72d2da0a1007afaf24e25c72a11";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contadorsolo.svg
// module id = 461
// module chunks = 0